import React, {ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import {PokerStore} from 'app/store/PokerStore';
import PokerContainer from 'app/components/poker/PokerContainer';

interface Props {
    pokerStore?: PokerStore
}

@inject('pokerStore')
@observer
export default class PokerTableList extends React.Component<Props> {
    render(): ReactNode {
        const {pokerStore} = this.props;

        return <>
            {Array.from(pokerStore.currentTables.values()).map(t => <PokerContainer
                key={t.currentTable.id}
                table={t}
            />)}
        </>;
    }
}
